<!--================================
=            DATEGROUPS            =
=================================-->
<template>
  <!-- WIDGETS CARDS -->
  <v-container>
    <v-row no-gutters>
      <base-header>
        <div slot="page-header">Date Pickers</div>
      </base-header>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Playground</div>
          <div slot="card-body">
            <v-row class="pa-5" justify="space-around">
              <v-col cols="12">
                <v-row justify="space-around">
                  <v-switch v-model="landscape" class="ma-4" label="Landscape"></v-switch>
                  <v-switch v-model="reactive" class="ma-4" label="Reactive"></v-switch>
                  <v-switch v-model="fullWidth" class="ma-4" label="Full width"></v-switch>
                  <v-switch v-model="showCurrent" class="ma-4" label="Show current date"></v-switch>
                  <v-switch v-model="month" class="ma-4" label="Month picker"></v-switch>
                  <v-switch v-model="multiple" class="ma-4" label="Multiple"></v-switch>
                  <v-switch v-model="readonly" class="ma-4" label="Readonly"></v-switch>
                  <v-switch v-model="disabled" class="ma-4" label="Disabled"></v-switch>
                  <v-switch v-model="enableEvents" class="ma-4" label="Events"></v-switch>
                </v-row>
              </v-col>

              <v-date-picker
                v-model="picker"
                :landscape="landscape"
                :reactive="reactive"
                :full-width="fullWidth"
                :show-current="showCurrent"
                :type="month ? 'month' : 'date'"
                :multiple="multiple"
                :readonly="readonly"
                :disabled="disabled"
                :events="enableEvents ? functionEvents : null"
              ></v-date-picker>
            </v-row>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Date pickers - Colors</div>
          <div slot="card-body">
            <v-row class="pa-5" justify="space-around">
              <v-date-picker v-model="picker" color="green lighten-1"></v-date-picker>
              <v-date-picker v-model="picker2" color="green lighten-1" header-color="primary"></v-date-picker>
            </v-row>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Date pickers - Allowed dates</div>
          <div slot="card-body">
            <v-row justify="center" class="pa-5">
              <v-date-picker
                v-model="date"
                :allowed-dates="allowedDates"
                class="mt-4"
                min="2016-06-15"
                max="2018-03-20"
              ></v-date-picker>
            </v-row>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Date pickers - Allowed dates</div>
          <div slot="card-body">
            <div>
              <v-row align="center" class="pa-5">
                <v-date-picker v-model="date" width="290" class="mt-4"></v-date-picker>
                <v-date-picker
                  v-model="date"
                  full-width
                  :landscape="$vuetify.breakpoint.smAndUp"
                  class="mt-4"
                ></v-date-picker>
              </v-row>
            </div>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Month pickers - Colors</div>
          <div slot="card-body">
            <v-row justify="space-around" class="pa-5">
              <v-date-picker v-model="picker" color="green lighten-1"></v-date-picker>
              <v-date-picker v-model="picker2" color="green lighten-1" header-color="primary"></v-date-picker>
            </v-row>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Month pickers - Allowed months</div>
          <div slot="card-body">
            <v-row justify="center" class="pa-5">
              <v-date-picker
                v-model="date"
                :allowed-dates="allowedDates"
                class="mt-4"
                min="2016-06-15"
                max="2018-03-20"
              ></v-date-picker>
            </v-row>
          </div>
        </base-card>
      </v-col>
      <!-- WIDGETS  -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Month pickers - Multiple</div>
          <div slot="card-body">
            <div>
              <v-row align="center" class="pa-5">
                <v-date-picker v-model="date" width="290" class="mt-4"></v-date-picker>
                <v-date-picker
                  v-model="date"
                  full-width
                  :landscape="$vuetify.breakpoint.smAndUp"
                  class="mt-4"
                ></v-date-picker>
              </v-row>
            </div>
          </div>
        </base-card>
      </v-col>
      <!-- WIDGETS  -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Month pickers - Setting picker width</div>
          <div slot="card-body">
            <v-row class="pa-5">
              <v-col cols="12" sm="6" class="my-2 px-1">
                <v-date-picker
                  ref="picker"
                  v-model="date"
                  :picker-date.sync="pickerDate"
                  full-width
                ></v-date-picker>
              </v-col>
              <v-col cols="12" sm="6" class="my-2 px-10">
                <div class="title">Month news ({{ pickerDate || 'change month...' }})</div>
                <div class="subheading">Change month to see other news</div>
                <ul class="ma-4">
                  <li v-for="note in notes" :key="note">{{ note }}</li>
                </ul>
              </v-col>
            </v-row>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Month pickers - Internationalization</div>
          <div slot="card-body">
            <v-container class="pa-5">
              <v-row class="pa-5">
                <v-col cols="12" lg="6">
                  <v-menu
                    ref="menu1"
                    v-model="menu1"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="dateFormatted"
                        label="Date"
                        hint="MM/DD/YYYY format"
                        persistent-hint
                        prepend-icon="event"
                        @blur="date = parseDate(dateFormatted)"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="date" no-title @input="menu1 = false"></v-date-picker>
                  </v-menu>
                  <p>
                    Date in ISO format:
                    <strong>{{ date }}</strong>
                  </p>
                </v-col>

                <v-col cols="12" lg="6">
                  <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="computedDateFormatted"
                        label="Date (read only text field)"
                        hint="MM/DD/YYYY format"
                        persistent-hint
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="date" no-title @input="menu2 = false"></v-date-picker>
                  </v-menu>
                  <p>
                    Date in ISO format:
                    <strong>{{ date }}</strong>
                  </p>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Month pickers - icons</div>
          <div slot="card-body">
            <v-container class="pa-5">
              <v-row class="pa-5">
                <v-col cols="12" lg="6">
                  <v-menu v-model="menu1" :close-on-content-click="false" max-width="290">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="computedDateFormattedMomentjs"
                        clearable
                        label="Formatted with Moment.js"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="date" @change="menu1 = false"></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="12" lg="6">
                  <v-menu v-model="menu2" :close-on-content-click="false" max-width="290">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="computedDateFormattedDatefns"
                        clearable
                        label="Formatted with datefns"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="date" @change="menu2 = false"></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </base-card>
      </v-col>
      <!-- WIDGETS  -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Month pickers - read only</div>
          <div slot="card-body">
            <v-row class="pa-10">
              <v-col cols="12" sm="6">
                <v-date-picker v-model="dates" multiple></v-date-picker>
              </v-col>
              <v-col cols="12" sm="6">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="dates"
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-combobox
                      v-model="dates"
                      multiple
                      chips
                      small-chips
                      label="Multiple picker in menu"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-combobox>
                  </template>
                  <v-date-picker v-model="dates" multiple no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                    <v-btn text color="primary" @click="$refs.menu.save(dates)">OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </div>
        </base-card>
      </v-col>
      <!-- WIDGETS  -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Month pickers - current month indicator</div>
          <div slot="card-body">
            <v-row justify="space-around" class="pa-5">
              <v-date-picker v-model="picker" :first-day-of-week="0" locale="zh-cn"></v-date-picker>
              <v-date-picker v-model="picker" :first-day-of-week="1" locale="sv-se"></v-date-picker>
            </v-row>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Date pickers - In dialog and menu</div>
          <div slot="card-body">
            <v-row justify="center" class="pa-5">
              <v-date-picker
                v-model="picker"
                year-icon="mdi-calendar-blank"
                prev-icon="mdi-skip-previous"
                next-icon="mdi-skip-next"
              ></v-date-picker>
            </v-row>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Date pickers - formatting date</div>
          <div slot="card-body">
            <v-row justify="center" class="pa-5">
              <v-date-picker v-model="date" readonly></v-date-picker>
            </v-row>
          </div>
        </base-card>
      </v-col>
      <!-- WIDGETS  -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Date pickers - formatting date using external libs</div>
          <div slot="card-body">
            <v-row justify="space-around" class="pa-5">
              <v-date-picker v-model="date1" :show-current="false"></v-date-picker>
              <v-date-picker v-model="date2" show-current="2013-07-13"></v-date-picker>
            </v-row>
          </div>
        </base-card>
      </v-col>
      <!-- WIDGETS  -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Date pickers - Mutiple</div>
          <div slot="card-body">
            <v-row align="center" class="pa-10">
              <v-checkbox v-model="landscape" label="Landscape"></v-checkbox>
              <v-date-picker v-model="picker" :landscape="landscape" type="month"></v-date-picker>
            </v-row>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Date pickers - Range</div>
          <div slot="card-body">
            <v-row justify="space-around" class="pa-3">
              <v-date-picker v-model="picker" type="month" color="green lighten-1"></v-date-picker>
              <v-date-picker
                v-model="picker2"
                type="month"
                color="green lighten-1"
                header-color="primary"
              ></v-date-picker>
            </v-row>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Date pickers - birthday picker</div>
          <div slot="card-body">
            <v-row class="pa-5">
              <v-col cols="12" sm="6" md="4">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="date"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="date"
                      label="Picker in menu"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="date" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                    <v-btn text color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="12" sm="6" md="4">
                <v-dialog
                  ref="dialog"
                  v-model="modal"
                  :return-value.sync="date"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="date"
                      label="Picker in dialog"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="date" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="modal = false">Cancel</v-btn>
                    <v-btn text color="primary" @click="$refs.dialog.save(date)">OK</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="date"
                      label="Picker without buttons"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="date" @input="menu2 = false"></v-date-picker>
                </v-menu>
              </v-col>
              <v-spacer></v-spacer>
            </v-row>
          </div>
        </base-card>
      </v-col>
      <!-- WIDGETS  -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Date pickers - Events</div>
          <div slot="card-body">
            <v-row justify="center" class="pa-10">
              <v-date-picker
                v-model="date"
                :allowed-dates="allowedMonths"
                type="month"
                class="mt-4"
                min="2017-06"
                max="2019-10"
              ></v-date-picker>
            </v-row>
          </div>
        </base-card>
      </v-col>
      <!-- WIDGETS  -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Month pickers - In dialog and menu</div>
          <div slot="card-body">
            <v-row class="pa-5">
              <v-col cols="11" sm="5">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="date"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="date"
                      label="Picker in menu"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="date" type="month" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                    <v-btn text color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="11" sm="5">
                <v-dialog
                  ref="dialog"
                  v-model="modal"
                  :return-value.sync="date"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="date"
                      label="Picker in dialog"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="date" type="month" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="modal = false">Cancel</v-btn>
                    <v-btn text color="primary" @click="$refs.dialog.save(date)">OK</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>
            </v-row>
          </div>
        </base-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import BaseCard from "../../layout/Base/BaseCard.vue";
import BaseHeader from "../../layout/Base/BaseHeader.vue";
export default {
  components: {
    BaseCard,
    BaseHeader
  },
  data() {
    return {
      dates: ["2018-09-15", "2018-09-20"],
      menu: false,
      picker: new Date().toISOString().substr(0, 10),
      landscape: false,
      reactive: false,
      fullWidth: false,
      showCurrent: true,
      month: false,
      multiple: false,
      readonly: false,
      disabled: false,
      enableEvents: false,
      picker2: new Date().toISOString().substr(0, 10),

      date: new Date().toISOString().substr(0, 7),

      modal: false
    };
  },

  computed: {
    functionEvents() {
      return this.month ? this.monthFunctionEvents : this.dateFunctionEvents;
    }
  },

  methods: {
    dateFunctionEvents(date) {
      const [, , day] = date.split("-");
      if ([12, 17, 28].includes(parseInt(day, 10))) return true;
      if ([1, 19, 22].includes(parseInt(day, 10))) return ["red", "#00f"];
      return false;
    },
    monthFunctionEvents(date) {
      const month = parseInt(date.split("-")[1], 10);
      if ([1, 3, 7].includes(month)) return true;
      if ([2, 5, 12].includes(month))
        return ["error", "purple", "rgba(0, 128, 0, 0.5)"];
      return false;
    },
    allowedDates: val => parseInt(val.split("-")[2], 10) % 2 === 0
  }
};
</script>


<!--====  End of DATEGROUPS  ====-->
